import { Injectable } from '@angular/core';
import { BaseDAO } from './baseDAO';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import { CharterConflictRequest } from './vesselAvailabilityPreferencesDAO';
import { Observable } from 'rxjs/Observable';
import { HttpHeaders } from '@angular/common/http';
import { Moment } from 'moment';
import { BuyflowProductOffering } from 'anchor-shared/lib/model/interface/buyflowProductOffering';

@Injectable()
export class CharterVesselAvailabilityDAO extends BaseDAO<any> {
  constructor(public readonly apiHelper: ApiHelper) {
    super(apiHelper, ConstantMan.API.RESOURCE.CHARTER_VESSEL_AVAILABILITY);
  }

  public getAvailableProductsForDay(
    vesselId: number,
    availableOn: Moment,
  ): Observable<BuyflowProductOffering[]> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      `/get-products/${vesselId}/${availableOn.format('x')}`;
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<BuyflowProductOffering[]>(
      url,
      method,
      null,
      null,
      headers,
    );
  }

  public getMoreTimesForCharterRequest(
    vesselId: number,
    date: string,
    charterDuration: number,
  ): Observable<string[]> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      `/get-more-times/${vesselId}/${date}/${charterDuration}`;
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<string[]>(url, method, null, null, headers);
  }

  public isAvailable(
    conflictRequest: Partial<CharterConflictRequest>,
  ): Observable<CharterVesselAvailabilityResponse> {
    let url: string = this.apiHelper.getServiceName() + this.getResource();
    const method = 'PUT';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    const data = {
      conflictRequest: conflictRequest,
    };
    return this.apiHelper.apiCall<CharterVesselAvailabilityResponse>(
      url,
      method,
      null,
      data,
      headers,
    );
  }

  public isRangeAvailable(
    conflictRequest: Partial<CharterConflictRequest>,
  ): Observable<CharterVesselAvailabilityResponse> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/range-availability';
    const method = 'PUT';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    const data = {
      conflictRequest: conflictRequest,
    };
    return this.apiHelper.apiCall<CharterVesselAvailabilityResponse>(
      url,
      method,
      null,
      data,
      headers,
    );
  }
}

export interface CharterVesselAvailabilityResponse {
  available: boolean;
  reason: string;
  category: string;
}
